import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProjectPage from "../../pages/common/MangeProject/ProjectPage/ProjectPage";

const RoleAwareProjectPage = ({ role }) => {
  const navigate = useNavigate();
  const { projectId } = useParams();

  const handleBack = () => {
    navigate(`/${role}/manage-projects`);
  };

  const handleEdit = () => {
    navigate(`/${role}/edit-project/${projectId}`);
  };

  const handleDeleteSuccess = () => {
    navigate(`/${role}/manage-projects`);
  };

  const handleOpenCAF = () => {
    navigate(`/${role}/caf?projectId=${projectId}`);
  };

  const handleOpenPFR = () => {
    navigate(`/${role}/pfr?projectId=${projectId}`);
  };

  return (
    <ProjectPage
      role={role}
      onBack={handleBack}
      onEdit={handleEdit}
      onDeleteSuccess={handleDeleteSuccess}
      onOpenCAF={handleOpenCAF}
      onOpenPFR={handleOpenPFR}
    />
  );
};

export default RoleAwareProjectPage;
